export default "__VITE_ASSET__D688v95d__"